import { render, staticRenderFns } from "./commodity-classify.vue?vue&type=template&id=5b2fea0c&scoped=true&"
import script from "./commodity-classify.vue?vue&type=script&lang=js&"
export * from "./commodity-classify.vue?vue&type=script&lang=js&"
import style0 from "./commodity-classify.vue?vue&type=style&index=0&id=5b2fea0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2fea0c",
  null
  
)

export default component.exports